export type TextAlign = 'left' | 'center' | 'right';

export const alignClass = (align?: TextAlign) => {
    switch (align) {
        case 'center':
            return 'text-center';
        case 'right':
            return 'text-right';
        default:
            return 'text-left';
    }
};
